import React, { useState, useRef } from "react";
import { useNavigate} from "react-router-dom";
import signinBgPhoto from "../../../assets/img/signinBgPhoto.jpg";
import { useAuthState } from '../../../contexts/authcontext'
import { useLoadAuthUser } from "../../../hooks/authhooks";
import AuthCard from "../../../components/unauth/AuthCard";


const OTPForm = () => {
   
    const navigate = useNavigate()
    var { authUser, loginType } = useAuthState()
    var {isLoading, verifyUser, registerUser, signOutUser} = useLoadAuthUser()
    let phone = authUser ? authUser.phone : null
    const [v1, updateCode1] = useState('')
    const [v2, updateCode2] = useState('')
    const [v3, updateCode3] = useState('')
    const [v4, updateCode4] = useState('')
    const [v5, updateCode5] = useState('')
    const [resent, updateResent] = useState(false)
    const [wrongCode, updateWrongCode] = useState(false)

    const resendOTP = async () => {
        if (phone && !isNaN(parseInt(phone))){
            let newuser = (registerUser !== undefined) ? await registerUser({phone}) : null
            if (newuser){
                updateResent(true)
            }
        }

    }

    const goBackToEmailLogin = () => {
      signOutUser()
      navigate('/');
  }

    const submitVerification = async () => {
        let full_otp = `${v1}${v2}${v3}${v4}${v5}`
        let verified = (verifyUser !== undefined) ? await verifyUser(full_otp) : null
        if (!verified){
            updateWrongCode(true)
        }
    }

    const isValid = (value: string): boolean => ((parseInt(value) < 10 && value.length < 2) || value === '') ? true : false
    const input1 = useRef<HTMLInputElement | null>(null);
    const input2 = useRef<HTMLInputElement | null>(null);
    const input3 = useRef<HTMLInputElement | null>(null);
    const input4 = useRef<HTMLInputElement | null>(null);
    const input5 = useRef<HTMLInputElement | null>(null);

    var otp_input_style = 'font-open-sans text-[16px] h-[50px] w-[18%] m-[1%] bg-white p-2 rounded-md border-[1px] border-[#E9E9E9] text-[#000000] text-center'

    var new_forms = (
    <div className="flex flex-row justify-center">
      <input name="v1" ref={input1} type="text" onChange={e => updateField(e, "v1")} value={v1}  className={otp_input_style} />
      <input name="v2" ref={input2} type="text" onChange={e => updateField(e, "v2")} value={v2}  className={otp_input_style} />
      <input name="v3" ref={input3} type="text" onChange={e => updateField(e, "v3")} value={v3}  className={otp_input_style} />
      <input name="v4" ref={input4} type="text" onChange={e => updateField(e, "v4")} value={v4}  className={otp_input_style} />
      <input name="v5" ref={input5} type="text" onChange={e => updateField(e, "v5")} value={v5}  className={otp_input_style} />
    </div>
    )

    const updateField = (e: React.ChangeEvent<HTMLInputElement>, pos: string) => {
        if (pos === 'v1'){
          updateCode1(isValid(e.target.value) ? e.target.value : v1)
          if (e.target.value.length === 1) {
            input2?.current?.focus();
          }
        } else if (pos === 'v2'){
          updateCode2(isValid(e.target.value) ? e.target.value : v2)
          if (e.target.value.length === 1) {
            input3?.current?.focus();
          }
        } else if (pos === 'v3'){
          updateCode3(isValid(e.target.value) ? e.target.value : v3)
          if (e.target.value.length === 1) {
            input4?.current?.focus();
          }
        } else if (pos === 'v4'){
          updateCode4(isValid(e.target.value) ? e.target.value : v4)
          if (e.target.value.length === 1) {
            input5?.current?.focus();
          }
        } else if (pos === 'v5'){
          updateCode5(isValid(e.target.value) ? e.target.value : v5)
        }

    }

    let full_otp = `${v1}${v2}${v3}${v4}${v5}`
    const destination = phone && loginType === 'phone'
      ? `${phone.slice(0, 2)} (${phone.slice(2, 5)}) ${phone.slice(5, 8)}-${phone.slice(8, 12)}`
      : authUser?.username?.toLowerCase()
    const title = (authUser && authUser?.login_community?.name)
      ? `Login to ${authUser.login_community.name}`
      : 'Welcome Back!'

    return (
        <div className="relative flex min-h-screen w-full items-start justify-center overflow-y-auto bg-surface-canvas">
          <img src={signinBgPhoto} alt="" className="absolute inset-0 z-0 h-full w-full object-cover" />
          <div className="absolute inset-0 z-0 bg-gradient-to-b from-primaryDark-0/85 via-primaryDark-0/70 to-primary-tint" />
          <div className="relative z-[1] mx-auto mt-[120px] w-full px-4 pb-10">
            <div className="mx-auto w-full max-w-[460px]">
              <AuthCard
                title={title}
                subtitle={`Enter the one-time passcode sent to ${destination ?? ''}`}
                footNote="The code expires shortly. Check your spam folder if it hasn't arrived."
              >
                  {(wrongCode && !isLoading) ? (
                    <p className="mb-2 text-center font-open-sans text-[10px] font-medium text-[#a40000]">PLEASE ENTER CORRECT CODE</p>
                  ) : null}
                  {new_forms}
                  {
                      (resent) ? ( <p className="m-2 text-center font-open-sans text-[12px] font-normal text-green-500">VERIFICATION CODE RESENT</p> ) : (
                      <p onClick={resendOTP} className="m-2 cursor-pointer text-center font-open-sans text-[12px] font-normal text-[#2389FC] hover:text-[#2388fcaa]">DIDN’T RECIEVE THE CODE? RESEND</p>)
                  }
                  <div onClick={goBackToEmailLogin}>
                    <p  className="m-2 cursor-pointer text-center font-open-sans text-[12px] font-normal text-[#639bc6] hover:text-[#639bc6b4]">Wrong Email?</p>
                  </div>
                  <button className="auth-primary-btn mt-2"  disabled={!(full_otp && full_otp.length === 5)}  onClick={submitVerification}>Continue </button>
              </AuthCard>
            </div>
          </div>
        </div>
    )
}



export default OTPForm
